<template>
  <CdrList
    :data-ui="`${type}-items`"
    modifier="unordered"
    class="gearlist__list"
  >
    <li
      v-for="{ key, text } in items"
      :key="key"
      :data-ui="`${type}-item`"
    >
      {{ text }}
    </li>
  </CdrList>
</template>

<script>
import { CdrList } from '@rei/cedar';

export default {
  name: 'SessionGearlistListComponent',
  components: {
    CdrList,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
